import { cloneDeep, debounce } from 'lodash';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RECORD_TYPE } from '../../../constants/datatypes';
import { treeActions } from '../../../redux/slices/treeSlice';
import { getUpdatedData as getUpdatedDataInbound } from './NewRecord';
import { getUpdatedData as getUpdatedDataOutbound } from "./NewRecordOutbound";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey, getUniqueWorkflowItemIdFromArray } from '../../../utils/utilFunctions';
import { useTranslation } from 'react-i18next';

function NewComment(props) {
    const {t} = useTranslation();
    const { openModal, toggle } = props;
    const [showModal, setShowModal] = useState(false);
    const [content,setContent] = useState('')
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector(state => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const templateHeader = rightTree.tree.templateHeader;
    const { currentScreen }  = useSelector(state => state.treeData)
    const dispatch = useDispatch();

    const addNewComment = (isNested) => {
        let nestedComments = selectedNode?.key?.split('-');
        nestedComments = nestedComments?.splice(1);
        const translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);
        const newId = getUniqueWorkflowItemIdFromArray(translatedData);

        // Creating details for new comment
        const getCommentDetails = (data, key) => {
            if (!data.length) return { key: `${key}-0`, title: t('COMMENT'), insertingPosition: 1 };
            let newCommentNumber = 0;
            let insertingPosition = 1;
            let flag = false;

            data?.forEach((element, index) => {
                const commentTitle = element?.MAPNAME;
                if (commentTitle && commentTitle?.startsWith(t('COMMENT'))) {
                    // const commentRecord = Number(commentTitle?.slice(9)?.replace(')', ''));
                    // if (!isNaN(commentRecord) && element.ICON_DISPLAY === 'COMMENT') {
                    if (element.ICON_DISPLAY === 'COMMENT') {
                        flag = true;
                        // newCommentNumber = commentRecord > newCommentNumber ? commentRecord : newCommentNumber;
                    }
                }
                if (element.key === selectedNode?.key) insertingPosition = index + 2;
            });

            const lastCommentKey = data[data.length - 1]?.key?.split('-');
            lastCommentKey[lastCommentKey.length - 1] = +lastCommentKey[lastCommentKey.length - 1] + 1;
            const newCommentKey = lastCommentKey?.join('-');
            
            if(currentScreen === 'workflow'){
              return {
                key: newCommentKey,
                title: getNewCommentTitle(rightTree.tree),
                insertingPosition
              }
            }
            return {
                key: newCommentKey,
                title: !flag ? 'Comment' : `Comment (${newCommentNumber ? +newCommentNumber + 1 : 1})`,
                insertingPosition
            }
        }

        // Adding new comment
        const insertNewComment = (translatedData, nestedComments, isNested) => {
            const level = isNested ? 0 : 1;
            if (nestedComments?.length === level) {
                const { children, key } = translatedData;
                const newCommentDetails = children
                    ? getCommentDetails(children, key)
                    : getCommentDetails(translatedData, currentScreen === 'inbound' ? 'ib' : currentScreen === 'outbound' ? {header: "obh-0", body: "ob-0", trailer: "obt-0"}[currentTab] : 'wf');

                // Creating new comment
                const newComment = {
                    key: newCommentDetails?.key,
                    title: currentScreen === 'workflow' ? newCommentDetails?.title : `${t('LBL_COMMENT')}`,
                    ICON_DISPLAY: 'COMMENT',
                    type: "COMMENT",
                    COMMENT: " ",
                    nodeId:genKey(newCommentDetails.title),
                    alternateNodeId:genKey(newCommentDetails.title),
                    ...(currentScreen === 'workflow' && { ACTION: 'COMMENT', ID: newId, ENABLED: "FALSE", LOG_WFITEM_DETAILS: "FALSE", NAME: newCommentDetails?.title }),
                };
                if (children) {
                    if (isNested) {
                        translatedData.children.splice(0, 0, newComment);
                        let newKey = selectedNode.key.split('-');
                        newKey.push('0')
                        newKey = newKey.join('-');
                        // newComment.RECORD_TYPE = translatedData?.title;
                        dispatch(treeActions.setRightTreeSelectedNode({
                            screen: parentScreen,
                            type: currentTab,
                            data: { ...newComment, key: newKey }
                        }));
                    } else {
                        const tempKey = selectedNode?.key?.split('-');
                        const lastIndex = + tempKey[tempKey.length-1] + 1

                        if(selectedNode?.ICON_DISPLAY === 'CONDITION_IF' && translatedData?.children[lastIndex]?.ICON_DISPLAY === "CONDITION_ELSE"){
                            translatedData.children.splice(lastIndex+1, 0, newComment);
                            let newKey = selectedNode.key.split('-');
                            newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 2;
                            newKey = newKey.join('-');
                            //  newNode.RECORD_TYPE = selectedNode?.RECORD_TYPE;
                            dispatch(treeActions.setRightTreeSelectedNode({
                                screen: parentScreen,
                                type: currentTab,
                                data: { ...newComment, key: newKey }
                            }));
                        }
                        else{
                        translatedData.children.splice(newCommentDetails.insertingPosition - 1, 0, newComment);
                        let newKey = selectedNode.key.split('-');
                        newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 1;
                        newKey = newKey.join('-');
                        // newComment.RECORD_TYPE = selectedNode?.RECORD_TYPE;
                        dispatch(treeActions.setRightTreeSelectedNode({
                            screen: parentScreen,
                            type: currentTab,
                            data: { ...newComment, key: newKey }
                        }));
                    }
                }
                }
                return;
            }
            const isArray = Array.isArray(translatedData);
            if (isArray) {
                const nestedData = translatedData[[nestedComments?.[0]]];
                const newNestedComments = nestedComments?.splice(1);
                insertNewComment(nestedData, newNestedComments, isNested);
            } else insertNewComment(translatedData?.children, nestedComments, isNested);
            return;
        }

        insertNewComment(translatedData, nestedComments, isNested);
        const updatedTranslatedContent = currentScreen === 'inbound' ? getUpdatedDataInbound(translatedData, templateHeader?.FILETYPE) : currentScreen === 'outbound' ? getUpdatedDataOutbound(translatedData, templateHeader?.FILETYPE, false, false, currentTab) : getUpdatedDataInbound(translatedData,null,'workflow');

        dispatch(treeActions.setNewRightTreeTranslatedData({
            screen: parentScreen,
            type: currentTab,
            data: updatedTranslatedContent
        }));
        setShowModal(false);
        toggle();
    }

    const newCommentHandelar = () => {
        if (selectedNode.key.split("-").length === 2) {
            addNewComment(true)
        }
        else if (['FIELD_GROUP','REPEATING_FIELD_GROUP'].includes(selectedNode?.ICON_DISPLAY)) {
            setContent(t('BOX_LIKE_TO_PLACE_FLD_INSIDE_CURR_FLDGRP_OR_DIRECTLY_AFTER'));
            setShowModal(true);
        } else if (selectedNode?.ICON_DISPLAY === 'COMMENT') {
            // toggle();
            addNewComment(false)
        }
        else if (selectedNode.ICON_DISPLAY === "QUERY") {
            addNewComment(false)
        }
        else if (["CONDITION_IF", "CONDITION_ELSE", "LOOP_ITEM"].includes(selectedNode.ICON_DISPLAY) && openModal) {
            setContent(t('BOX_LIKE_TO_PLACE_ITEM_INSIDE_CURR_REC_OR_DIRECTLY_AFTER'));
            setShowModal(true);
        }
        else if (!RECORD_TYPE[selectedNode.ICON_DISPLAY] && openModal) {
            addNewComment(false);
        }
        // No need to show modal in inbound while creating comment inside of record.
        else if (RECORD_TYPE[selectedNode.ICON_DISPLAY] && openModal && parentScreen === 'inbound') {
            addNewComment(true);
        }else {
            setContent(t('BOX_LIKE_TO_PLACE_ITEM_INSIDE_CURR_REC_OR_DIRECTLY_AFTER'));
            setShowModal(true);
        }
    }
    useEffect(() => {
        if (openModal) {
            newCommentHandelar();
        }
    }, [openModal])

    return (
        <Dialog open={showModal} maxWidth="xs" fullWidth>
            <DialogTitle className="dialog-header">
                <div className="title">
                    {t("BOX_CONFIRM")}
                </div>
            </DialogTitle>
            <DialogContent className="dialog-content" dividers>
                <div>{content.split(`\\n`).map((str, idx) => <div key={idx}>{str ? str : <br />}</div>)}</div>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant="outlined" color="primary" onClick={() => addNewComment(true)} >
                    {t("BTN_YES")}
                </Button>
                <Button size='small' variant="outlined" color="primary" onClick={() => addNewComment(false)} >
                    {t("BTN_NO")}
                </Button>
                <Button size='small' variant="outlined" color="primary" onClick={() => {
                    toggle(null);
                    setShowModal(false);
                }} >
                    {t("BTN_CANCEL")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default NewComment

export const getNewCommentTitle = (tree) => {
  const data = cloneDeep(tree);
  const body = data.body.translatedData;
  let titleNumber = 0;
  let hasPlainGetData = false; 

  const getTitleName = (data) => {
    data.forEach((ele) => {
      if (ele?.title?.startsWith("Comment")) {
        const title = ele.title;
        const openParenIndex = title.indexOf("(");
        const closeParenIndex = title.indexOf(")");

        if (openParenIndex > -1 && closeParenIndex > openParenIndex) {
          // Extract the number between parentheses
          const numberPart = title.slice(openParenIndex + 1, closeParenIndex).trim();
          const parsedNumber = parseInt(numberPart, 10);

          if (!isNaN(parsedNumber)) {
            titleNumber = Math.max(titleNumber, parsedNumber);
          }
        } else {
          hasPlainGetData = true;
        }
      }

      if (ele?.children?.length > 0) {
        getTitleName(ele.children);
      }
    });
  };

  getTitleName(body);

  // If "Comment" exists without parentheses
  if (hasPlainGetData && titleNumber === 0) {
    return "Comment (1)";
  }

  return titleNumber === 0 ? "Comment" : `Comment (${titleNumber + 1})`;
};